import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoImage } from "@/components/Brand";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-canvas">
        <div className="flex flex-col items-center gap-4">
          <LogoImage size="lg" withText={false} />
          <div className="h-1 w-32 overflow-hidden rounded-full bg-brand-line">
            <div className="h-full w-1/2 rounded-full bg-brand-accent" style={{ animation: "shimmer 1.2s infinite" }} />
          </div>
        </div>
      </div>
    );
  }

  if (user === false) return <Navigate to="/acceso" replace />;
  return children;
}
